module.exports = __webpack_public_path__ + "img/dsci0013.bb5d1c16.jpg";